"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFuturesOrderProcessor = void 0;
const interface_1 = require("../../../interface");
const useActiveOrderList_1 = require("./useActiveOrderList");
const useFundingFee_1 = require("./useFundingFee");
const useHistoryOrderList_1 = require("./useHistoryOrderList");
const useMarginRecords_1 = require("./useMarginRecords");
const useOrderDetails_1 = require("./useOrderDetails");
const useOrderStats_1 = require("./useOrderStats");
const useListenOrderStatusChange_1 = require("./useListenOrderStatusChange");
const useAllOrderList_1 = require("./useAllOrderList");
var SimpleFuturesOrderProcessor;
(function (SimpleFuturesOrderProcessor) {
    /** 活跃仓位列表 */
    SimpleFuturesOrderProcessor.useActiveOrderList = useActiveOrderList_1.useActiveOrderList;
    /** 简易仓位列表（不限制分页；数据包括条件单和活跃订单，每次有开、关单、止赢止损修改就会刷新数据） */
    SimpleFuturesOrderProcessor.useAllOrderList = useAllOrderList_1.useAllOrderList;
    /** 历史仓位列表 */
    SimpleFuturesOrderProcessor.useHistoryOrderList = useHistoryOrderList_1.useHistoryOrderList;
    /** 资金费列表 */
    SimpleFuturesOrderProcessor.useFundingFee = useFundingFee_1.useFundingFee;
    /** 保证金列表 */
    SimpleFuturesOrderProcessor.useMarginRecords = useMarginRecords_1.useMarginRecords;
    /** 仓位详情 */
    SimpleFuturesOrderProcessor.useOrderDetails = useOrderDetails_1.useOrderDetails;
    /** 判断此时的订单的强平价字段是否为有效状态 */
    SimpleFuturesOrderProcessor.isMaintPriceValid = (order) => {
        var _a;
        let mainLoopRes = false;
        if (order.mode === interface_1.SimpleFutures.OrderMode.Limit) {
            mainLoopRes = order.main_loop_status === "idle_check" || order.main_loop_status === "check_order";
        }
        else {
            mainLoopRes = order.main_loop_status === "idle_check";
        }
        return order.inner_status === "main_loop" && mainLoopRes && Number((_a = order.maint_price) !== null && _a !== void 0 ? _a : -1) >= 0;
    };
    /** 仓位统计（后端还不支持 wss 推送；支持后，这个 hooks 和使用的地方都要重构） */
    SimpleFuturesOrderProcessor.useOrderStats = useOrderStats_1.useOrderStats;
    /** 监听仓位状态变化 */
    SimpleFuturesOrderProcessor.useListenOrderStatusChange = useListenOrderStatusChange_1.useListenOrderStatusChange;
})(SimpleFuturesOrderProcessor = exports.SimpleFuturesOrderProcessor || (exports.SimpleFuturesOrderProcessor = {}));
